<div id="wt">
  <button type="button" class="close text-primary m-2" aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
    <i class="fas fa-times-circle"></i>
  </button>
  <div class="modal-header d-flex justify-content-center border-bottom-0">
    <div>
      <h5 class="modal-title">Devolver Requerimientos</h5>
    </div>
  </div>
  <div class="modal-body">

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-group">
      @if (customfieldsRequirementType) {
        <app-customfields [fields]="customfieldsRequirementType" (customfieldsValues)="getCustomfieldsValues($event)"
          [terminarCausa]="false" [customfieldsAlls]="[]" [isSubGrupo]="false"
          [flagActionLog]="false" [resultCustomfieldsSubGrop]="[]">
        </app-customfields>
      }
      <input type="hidden" id="requirementids" value="{{requirementIds}}">
      <input type="hidden" id="actionid" value="{{actionid}}">


      <div class="modal-footer border-top-0 justify-content-center">


        <button type="submit" class="btn btn-outline-primary bg-white rounded-pill text-dark font-weight-bold" style="width: 120px"
          [disabled]="isSubmitting">
          @if (isSubmitting) {
            <div class="d-flex align-items-center justify-content-center">
              <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Cargando...
            </div>
          }
          @if (!isSubmitting) {
            <span>Devolver</span>
          }
        </button>
      </div>
    </form>
  </div>
</div>
